import { createContext, useContext, useEffect, useMemo, useReducer, useRef } from "react";
import { appStateI, appStateReducer } from "./reducers/appStates";
import { contextModelI, contextModelReducer } from "./reducers/contextModels";
import { contextReducer, contextI } from "./reducers/contexts";
import { experimentI, experimentReducer } from "./reducers/experiments";

const combineReducers = (reducers: any) => {
  return (state: any, action: any) => {
    return Object.keys(reducers).reduce(
      (prevState, key) => ({
        ...prevState,
        [key]: reducers[key](state[key], action),
      }),
      state
    );
  };
};

const rootReducer = combineReducers({
  contexts: contextReducer,
  contextModels: contextModelReducer,
  experiments: experimentReducer,
  appStates: appStateReducer,
});

const initialState = {
  contexts: contextI,
  contextModels: contextModelI,
  experiments: experimentI,
  appStates: appStateI,
};

const enchanceDispatchWithLogger = (dispatch: any) => {
  return function (action: any) {
    // console.groupCollapsed('Action Type:', action.type);
    console.log("Action Type:", action.type);
    return dispatch(action);
  };
};

const useReducerWithLogger = (reducer: any, initialState: any) => {
  let prevState = useRef(initialState);
  const [state, dispatch] = useReducer(reducer, initialState);
  const dispatchWithLogger = useMemo(() => {
    return appEnableStoreLog ? enchanceDispatchWithLogger(dispatch) : dispatch;
  }, [dispatch]);

  useEffect(() => {
    if (appEnableStoreLog && state !== initialState) {
      // console.log('Prev state: ', prevState.current);
      // console.log('Next state: ', state);
      // console.groupEnd();
    }
    prevState.current = state;
  }, [state]);

  return [state, dispatchWithLogger];
};

export const StoreContext = createContext({});
export const useStateValue = () => useContext(StoreContext);
export const StoreProvider = ({ children }: any) => {
  const [state, dispatch] = useReducerWithLogger(rootReducer, initialState);
  const store = useMemo(() => [state, dispatch], [state]);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};
